import { IAccountJSON } from "../../interfaces/serviceModels/IAccountsJSON";
import { setCURRENTACCOUNTOBJECT } from "../constants/currentAccountObject.types";

export const setCurrentAccountObject = (accountObject: IAccountJSON | null) => {
  return {
    type: setCURRENTACCOUNTOBJECT,
    payload: accountObject,
  };
};
